// extracted by mini-css-extract-plugin
export default {"share":"share_share__gAfXh","allButton":"share_allButton__fh1Cl"};